export interface ProfileAvatarProps extends React.DetailedHTMLProps<React.BaseHTMLAttributes<HTMLBaseElement>, HTMLBaseElement>{
    loading?: boolean;
    avatar?: string;
}

export const AvatarMap: Record<string, any> = {
  default: require('../../assets/profile/avatars/hacker.png'),
  hacker: require('../../assets/profile/avatars/hacker.png')
}
